/**
 *
 * Checks to make sure the window object and the google analytics queue are available before logging events. For more information on what data should be passed in, read [these docs](https://developers.google.com/analytics/devguides/collection/gtagjs/events).
 *
 * The data passed in should be the event action, event category, event label and event value though only the category and action are required.
 *
 * ```js
 * import { gaEvent } from '@minerva-analytics/pantheon';
 *
 * gaEvent(['click', 'button', 'home-page', <user ID>]);
 * ```
 *
 * @param {Array} data - data for the given GA event
 */

/* eslint-disable */
var gaEvent = function gaEvent(data) {
  if (window && window.gtag) {
    gtag('event', data[1], {
      event_category: data[0],
      event_label: data[2] || '',
      value: data[3] || null
    });
  }
};
/* eslint-enable */


export default gaEvent;